	'use strict';

	angular.module('cvsApp', [
							   'ngRoute',
							   'ngResource',
							   'app.config',
								'app.core',
								'logger'
							   ])
							   .config(['$routeProvider', '$httpProvider', '$provide','$sceProvider', function ($routeProvider, $httpProvider, $provide,$sceProvider) {


								   $routeProvider.when('/', {
									   templateUrl: 'app/views/loader.html',
									   controller: 'loaderCtrl'
								   });

								   $routeProvider.when('/error', {
									   templateUrl: 'app/views/error.html'
								   });

								   $routeProvider.otherwise({
									   redirectTo: '/'
								   });

								   //Enable cross domain calls
								   $httpProvider.defaults.useXDomain = true;
								   $sceProvider.enabled(false);


								   //Remove the header used to identify ajax call  that would prevent CORS from working
								   //delete $httpProvider.defaults.headers.common['X-Requested-With'];
								   $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

							   }])
		/*.directive('ngLoadings', function ($compile) {

		var loadingSpinner = '<div class="row"><div class="col-lg-8 col-md-8 col-xs-8 col-sm-8 col-xs-offset-2 loader-panel"><img src="../common/images/caremark_spinner.gif" class="loader-img"/><div class="loader-img"><b>Loading</b></div></div></div>';

		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				var originalContent = element.html();
				//element.html(loadingSpinner);
				scope.$watch(attrs.ngLoading, function (val) {
					if(val) {
						//element.html(originalContent);
						$compile(element.contents())(scope);
					} else {
						//element.html(loadingSpinner);
					}
				});
			}
		};
	});*/;
